import { render, staticRenderFns } from "./SetBiometricHourModal.vue?vue&type=template&id=34dbe2c3&"
import script from "./SetBiometricHourModal.vue?vue&type=script&lang=js&"
export * from "./SetBiometricHourModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports